// src/pages/LearnMore.tsx
import React from "react";
import { Link } from "react-router-dom";
import {
  FaMicrophone, FaBullhorn, FaCalendarAlt,
  FaLink, FaToggleOn, FaMoneyBillWave, FaGlobe,
} from "react-icons/fa";
import "./Home.css";
import "./LearnMore.css";

const FEATURES = [
  { icon: <FaMicrophone />, label: "Paid Song Requests & Tips" },
  { icon: <FaBullhorn />, label: "Promo & Shoutout Requests" },
  { icon: <FaCalendarAlt />, label: "Booking Requests" },
  { icon: <FaLink />, label: "Your Own Monetization Link" },
  { icon: <FaToggleOn />, label: "Real-Time Approval Controls" },
  { icon: <FaMoneyBillWave />, label: "Transparent Payouts" },
];

const LearnMore: React.FC = () => {
  return (
    <div className="home learn-more-page">

      {/* ── Hero Header ── */}
      <section className="lm-hero">
        <div className="lm-hero-bg" aria-hidden>
          <div className="hero-bg-texture" />
          <div className="lm-orb lm-orb--1" />
          <div className="lm-orb lm-orb--2" />
        </div>
        <Link to="/" className="lm-back-link">← Back</Link>
        <span className="hero-pill">
          <span className="hero-pill-icon">✦</span>
          How It Works
        </span>
        <h1 className="lm-title">
          Everything you need to<br />
          <span className="heading-accent">start earning.</span>
        </h1>
        <p className="lm-tagline">The Income Layer for Live Entertainment</p>
        <p className="lm-subtitle">
          One link. Multiple revenue streams. Full control.
        </p>
      </section>

      {/* ── 3 Steps ── */}
      <section className="section section-dark">
        <h2 className="section-heading">
          <span className="heading-accent">3 Simple</span> Steps
        </h2>
        <div className="steps">
          <div className="step-card">
            <div className="step-number-row">
              <div className="step-number">1</div>
            </div>
            <h3>Get Discovered</h3>
            <p>
              Share your Request link in your social bios, on stage, or anywhere
              online. Fans find you instantly.
            </p>
          </div>
          <div className="step-card">
            <div className="step-number-row">
              <div className="step-number">2</div>
            </div>
            <h3>Receive Requests</h3>
            <p>
              Fans pay to request songs, promos, bookings, features, playlists,
              and more — all in one place.
            </p>
          </div>
          <div className="step-card">
            <div className="step-number-row">
              <div className="step-number">3</div>
            </div>
            <h3>Earn Big</h3>
            <p>
              Set up banking once. You decide when, how much, and how often
              you get paid. Full transparency.
            </p>
          </div>
        </div>
      </section>

      {/* ── Feature Grid ── */}
      <section className="section section-dark">
        <h2 className="section-heading">
          Built for <span className="heading-accent">Performers</span>
        </h2>
        <div className="lm-features-grid">
          {FEATURES.map((f) => (
            <div key={f.label} className="lm-feature-card">
              <div className="lm-feature-icon">{f.icon}</div>
              <span className="lm-feature-label">{f.label}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="section section-dark section-cta">
        <h2 className="section-heading section-heading-lg">
          Ready to <span className="heading-accent">start earning?</span>
        </h2>
        <p className="section-text">
          Setup takes minutes. Your first request could come today.
        </p>
        <div className="cta-buttons">
          <a href="/register" className="btn btn-green-glow btn-lg">
            Join as talent
          </a>
          <Link to="/" className="btn btn-outline-white btn-lg">
            Back to Home
          </Link>
        </div>
      </section>

    </div>
  );
};

export default LearnMore;
